import type { IconProps } from '../types/IconProps.ts';
export const Eraser: IconProps = {
    name: 'Eraser',
    children: [
        `<path d="M22 21h-9m0 0H8.46a1 1 0 0 1-.76-.35L2.6 14.7a1 1 0 0 1 .05-1.35L13.3 2.7a1 1 0 0 1 1.42 0l7.12 7.12a1 1 0 0 1 .03 1.38zM5.64 10.59 14 19" />`,
    ]
};